import React from 'react'
// components
import ReviewsList from 'components/Modals/PlanItems/components/ReviewsList'
// context
import ReviewsListBL from 'containers/Review/ReviewList/layers/BL/index'

const ReviewsListContainer = props => (
  <ReviewsListBL {...props}>
    <ReviewsList />
  </ReviewsListBL>
)

export default ReviewsListContainer
